// src/cert/kosher.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const Kosher = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>Kosher प्रमाणन</h1>
                <p>यहूदी अन्न कायद्यानुसार शुद्धता (Jewish Dietary Laws)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>Kosher म्हणजे काय?</h2>
                    <p>
                        product to be kosher certified, and to qualify for a kosher certificate, each ingredient, food additive and processing aid used in its production must also be kosher. Additionally, to be kosher certified, the production process must be suitable for kosher requirements and therefore it must be approved by a kosher auditor. Products may be rendered non-kosher if their production lines and equipment are also used to manufacture non-kosher products.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>यहूदी समुदायाचा (15 मिलियन+) विश्वास मिळवतो</li>
                        <li>USA, इजरायल, युरोप, भारतात निर्यात आणि बाजार वाढ</li>
                        <li>अन्न शुद्धता, स्वच्छता, ट्रेसेबिलिटी सुनिश्चित</li>
                        <li>Kosher लोगो (OU, OK, Star-K) — ब्रँड मूल्य वाढते</li>
                        <li>व्हेजिटेरियन/व्हेगनसाठी देखील स्वीकारले जाते</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>Kosher प्रमाणनासाठी अर्ज करा</h2>
                    <ApplyForm certification="Kosher" />
                </section>
            </div>
        </div>
    );
};

export default Kosher;